<template>
  <div>
    <s-form @submit="submit" class="h-remove-child-margin">
      <p class="m-form-group">
        <label class="a-form-label" for="name">{{ $t('label-entrepreneur-name') }}*</label>
        <input class="a-form-control" id="name" v-model.trim="$v.name.$model" />
        <span v-if="$v.name.$dirty">
          <span class="m-form-group__error" v-if="!$v.name.required">{{ $t('error-field-required') }}</span>
        </span>
      </p>

      <div class="m-form-group">
        <label class="a-form-label">{{ $t('label-entrepreneur-birthdate') }}</label>
        <p>
          <label class="a-form-label" for="month">
            <span class="m-form-group__note">{{ $t('label-entrepreneur-month') }}</span>
          </label>
          <select id="month" class="a-form-control a-form-control--inline" v-model="month">
            <option disabled value="">{{ $t('select-month-none') }}</option>
            <option value="1">{{ $t('select-month-january') }}</option>
            <option value="2">{{ $t('select-month-february') }}</option>
            <option value="3">{{ $t('select-month-march') }}</option>
            <option value="4">{{ $t('select-month-april') }}</option>
            <option value="5">{{ $t('select-month-may') }}</option>
            <option value="6">{{ $t('select-month-june') }}</option>
            <option value="7">{{ $t('select-month-july') }}</option>
            <option value="8">{{ $t('select-month-august') }}</option>
            <option value="9">{{ $t('select-month-september') }}</option>
            <option value="10">{{ $t('select-month-october') }}</option>
            <option value="11">{{ $t('select-month-november') }}</option>
            <option value="12">{{ $t('select-month-december') }}</option>
          </select>
        </p>

        <p>
          <label class="a-form-label" for="year">
            <span class="m-form-group__note">{{ $t('label-entrepreneur-year') }}</span>
          </label>
          <select id="year" class="a-form-control a-form-control--inline" v-model="year">
            <option disabled value="">{{ $t('select-year-none') }}</option>
            <option v-for="n in 18" :value="thisYear - n" :key="n">{{ thisYear - n }}</option>
          </select>
        </p>
      </div>

      <p class="m-form-group">
        <label class="a-form-label" for="gender">{{ $t('label-entrepreneur-gender') }}</label>
        <select id="gender" class="a-form-control a-form-control--inline" v-model="gender">
          <option disabled value="0">{{ $t('select-gender-none') }}</option>
          <option value="1">{{ $t('select-gender-male') }}</option>
          <option value="2">{{ $t('select-gender-female') }}</option>
          <option value="3">{{ $t('select-gender-other') }}</option>
        </select>
      </p>

      <p class="m-form-group">
        <button class="a-btn-primary a-btn-primary--small" type="submit">
          {{ submitBtnLabel }}
        </button>
      </p>
    </s-form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import SForm from '@/components/form/form'

export default {
  components: {
    SForm
  },
  props: {
    submitBtnLabel: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    month: {
      type: String,
      required: true
    },
    year: {
      type: String,
      required: true
    },
    gender: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      thisYear: new Date().getFullYear()
    }
  },
  methods: {
    submit: async function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('onEntrepreneurSubmit', { name: this.name, month: this.month, year: this.year, gender: this.gender })
      }
    }
  },
  validations: {
    name: {
      required
    }
  }
}
</script>
